import { Component, Inject } from '@angular/core';
import { ModalOverlayRef } from 'src/app/modal/modal-overlay-ref';
import { MODAL_DATA } from '../../modal.service';

@Component({
    selector: 'gl-too-much-loads',
    templateUrl: './too-much-loads.component.html',
    styleUrls: ['./too-much-loads.component.scss'],
    standalone: false
})
export class TooMuchLoadsComponent {
  public message: string;
  constructor(
    private modalRef: ModalOverlayRef,
    @Inject(MODAL_DATA) public data
  ) {
    this.message = this.data.message;
    this.modalRef.backgroundClicked();
  }

  public close(result: boolean) {
    this.modalRef.close(result);
  }
}
